import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Reports } from "../api/agent";
import LoadingOverlay from "../loading/LoadingOverlay"; // Import the LoadingOverlay component
import Pagination from "../pagination/Pagination"; // Import the new Pagination component
import "../assets/css/pagination.css"



const Report = () => {
  const [isLoading, setIsLoading] = useState(false); // New loading state

  const [data, setData] = useState([]);
  const [reports, setReports] = useState([]);
  const [nextCount, setNextCount] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const { t } = useTranslation();

  useEffect(() => {
    Reports.get(1)
      .then((data) => {
        setData(data);
        setReports(data.data);
        setLastPage(data.last_page);
      })
      .catch((error) => console.log(error));
  }, []);

  // get previous page data
  const Prev = (page) => {
    setIsLoading(true); // Set loading state to true
   
    Reports.get(page - 1).then((data) => {
      setData(data);
      setReports(data.data);
      setNextCount(page - 1);
      setIsLoading(false); // Set loading state to false after data is fetched
    });
  };

  // get next page data
  const Next = (page) => {
    setIsLoading(true); // Set loading state to true
   
    Reports.get(page + 1).then((data) => {
      setData(data);
      setReports(data.data);
      setNextCount(page + 1);
      setIsLoading(false); // Set loading state to false after data is fetched
    });
  };


  const handlePageChange = (page) => {
    setIsLoading(true);


    Reports.get(page)
    .then((data) => {
      setData(data);
      setReports(data.data);
      setNextCount(page);
      setLastPage(data.last_page);
      setIsLoading(false);
    })

  };



  return (
    <div>
      <div
        className="breadcrumb-area breadcrumb-bg"
        style={{
          backgroundImage: `url(/assets/img/backgrounds/news-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="page-banner text-center">
                <h1>{t("reports")}</h1>
                <ul className="page-breadcrumb">
                  <li>
                    <Link to="/">{t("home")}</Link>
                  </li>
                  <li>{t("reports")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="service-grid-item grid--item rounded" >
        <Table responsive="md" className="service-grid-item--style3" >
          <thead>
            <tr>
              <th>#</th>
              <th>{t("title")}</th>
              <th>{t("publish_date")}</th>
            </tr>
          </thead>
          <tbody>
            {reports &&
              reports.map((val, i) => {
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td style={{ color: "#0055ffeb", cursor: "pointer" }}>
                      <Link
                        to={`${process.env.PUBLIC_URL}/report-details/${val.id}`}
                      >
                        {val.title}
                      </Link>{" "}
                    </td>
                    <td>{val.publish_date}</td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
      </div>
      <div className="row mb-5">
        <div className="col">


        <Pagination
            currentPage={data.current_page}
            lastPage={lastPage}
            onPrev={() => Prev(data.current_page)}
            onNext={() => Next(data.current_page)}
            onPageClick={(page) => handlePageChange(page)}
          />


          {/* <ul className="page-pagination section-space--top--10">
            <li>
              {nextCount > 1 ? (
                <a onClick={() => Prev(data.current_page)}>
                  <i className={`${t("prev_class")}`} /> {t("prev")}
                </a>
              ) : (
                <a className="disabled" title="First Page">
                  <i className={`${t("prev_class")}`} /> {t("prev")}
                </a>
              )}
            </li>

            <li>
              {nextCount < lastPage ? (
                <a onClick={() => Next(data.current_page)}>
                  <i className={`${t("next_class")}`} /> {t("next")}
                </a>
              ) : (
                <a className="disabled">
                  <i className={`${t("next_class")}`} /> {t("next")}
                </a>
              )}
            </li>
          </ul> */}
          {isLoading && <LoadingOverlay />} {/* Display the LoadingOverlay component when isLoading is true */}

        </div>
      </div>
    </div>
  );
};

export default Report;
